var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.36836 14.4904C2.78836 20.4988 7.88669 25.3871 13.9884 25.6554C18.2934 25.8421 22.1434 23.8354 24.4534 20.6738C25.41 19.3788 24.8967 18.5154 23.2984 18.8071C22.5167 18.9471 21.7117 19.0054 20.8717 18.9704C15.1667 18.7371 10.5 13.9654 10.4767 8.33044C10.465 6.81378 10.78 5.37878 11.3517 4.07211C11.9817 2.62544 11.2234 1.93711 9.76502 2.55544C5.14502 4.50378 1.98336 9.15878 2.36836 14.4904Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.4505d5a9e15d3b8d5b3903a9ececab32.svg";
export { ForwardRef as ReactComponent };